module.exports = __webpack_public_path__ + "media/images/cplook/favicon-16x16-5043e1c98273d3249fc9f821b9b025b3.png";